import { FieldTypeAsset, HeadlineVariation } from '@allesauto/utils/consts';
import { sbEditable } from '@storyblok/storyblok-editable';
import clsx from 'clsx';
import React, { FC } from 'react';

import Headline from '../headline';
import NextImage from '../nextImage';

export interface TestimonialProps {
  headlineClassName?: string;
  headline: string;
  headlineTag: HeadlineVariation.H1 | HeadlineVariation.H2;
  image?: FieldTypeAsset;
  name: string;
  company?: string;
  component: string;
  _uid: string;
  _editable?: string;
}

const Testimonial: FC<TestimonialProps> = (props) => {
  const {
    headlineClassName,
    headlineTag = HeadlineVariation.H2,
    headline,
    name,
    company,
    image,
  } = props;
  const imageUrl = image?.filename ?? null;

  const className = {
    containerClass: clsx(
      'col-end-23 col-start-3',
      [HeadlineVariation.H1, HeadlineVariation.H2].includes(headlineTag)
        ? 'lg:col-end-21 lg:col-start-5'
        : 'lg:col-end-12 lg:col-start-2'
    ),
    headlineWrapperClass: clsx(
      'break-words mb-20px',
      [HeadlineVariation.H1, HeadlineVariation.H2].includes(headlineTag) &&
        'lg:mb-40px'
    ),
    authorWrapperClass: 'flex items-center',
    imageWrapperClass:
      'h-[3.125rem] mr-10px relative w-[3.125rem] md:h-60px md:w-60px',
    imageClass: 'border-3px rounded-circle border-transparent',
    authorDetailsClass: 'font-regular text-grey100',
    nameClass: 'font-weight-bold text-p1',
    companyClass: 'font-weight-normal text-p3',
  };

  return (
    <div {...sbEditable(props)} className={className.containerClass}>
      <div className={className.headlineWrapperClass}>
        <Headline
          headlineClassName={headlineClassName}
          headlineTag={headlineTag}
          headlineText={headline}
          headlineColor="text-purple80"
        />
      </div>
      <div className={className.authorWrapperClass}>
        {imageUrl && (
          <div className={className.imageWrapperClass}>
            <NextImage
              useCustomLoader={false}
              alt={image?.alt || name}
              layout="fill"
              src={imageUrl}
              objectFit="cover"
              imgClassName={className.imageClass}
            />
          </div>
        )}
        <div className={className.authorDetailsClass}>
          <p className={className.nameClass}>{name}</p>
          <p className={className.companyClass}>{company}</p>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
